const Colors = {
    WHITE: "#FFFFFF",
    BLACK: "#000000",
    GRAY: "#808080",
    BLUE: "#10163b",
    ORANGE: "#fdb750",
    PURPLE: "#392A5F",
}

export default Colors;